export default currentRent => ({
  date: '',
  amount: '',
  currentRent,
  rentAfterContribution: ''
});
